export function isDocumentationApproved(status?: string) {
  return status === 'APROVADO'
}

export function needsSaleRegistration(documentationStatus?: string) {
  return documentationStatus === 'NAO_INICIADO' || documentationStatus === 'REPROVADO'
}

export function isSaleOperationBlocked(input: {
  isSaleBlocked?: boolean
  documentationStatus?: string
}) {
  return (
    input.isSaleBlocked === true ||
    (input.documentationStatus !== undefined && !isDocumentationApproved(input.documentationStatus))
  )
}

/** Payout restrictions come only from the observed onboarding operation. */
export function isPayoutOperationBlocked(input: {
  payouts?: 'waiting' | 'in_review' | 'released' | 'blocked'
}) {
  return input.payouts === 'blocked'
}
